import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTableModule } from 'ng-zorro-antd/table';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { MainCategoryService } from './main-category.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-main-category',
  imports: [DynamicTableComponent, NzPopconfirmModule, NzInputModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule],
  providers: [NzModalService],
  templateUrl: './main-category.component.html',
  styleUrl: './main-category.component.scss'
})
export class MainCategoryComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Main Category List",
    permissionKey: "maincategory",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "250px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "type",
        title: "Type",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [
          { value: 'User Post', text: 'User Post' },
          { value: 'Biz Post', text: 'Biz Post' },
          { value: 'Admin Post', text: 'Admin Post' },
          { value: 'Item', text: 'Item' }
        ],
        width: "250px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "250px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Group Name',
      name: 'parent',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },
    {
      label: 'Type',
      name: 'type',
      type: 'select',
      placeholder: 'Select Type',
      required: true,
      options: [
        { value: 'User Post', text: 'User Post' },
        { value: 'Biz Post', text: 'Biz Post' },
        { value: 'Admin Post', text: 'Admin Post' },
        { value: 'Item', text: 'Item' }
      ],
      dependOn: 'group_id',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Type required',
        },
      ],
    },
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    }
  ];
  width: string;

  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: MainCategoryService, private readonly cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.calculateWidth();

    forkJoin({
      groups: this.service.getGroupOption(),
      mainCategories: this.service.getItems()
    })
      .subscribe({
        next: ({ groups, mainCategories }) => {
          this.schema.columns[1].option = groups?.map((y: any) => ({
            text: y.name,
            value: y.name
          }));

          this.schema.columns[3].option = mainCategories?.data.map((y: any) => ({
            text: y.maincategory_name,
            value: y.maincategory_name
          }));

          this.fieldConfig[0].options = groups
            ?.filter((y: any) => y.level === 1)
            .map((y: any) => ({
              text: y.name,
              value: y.id,
              level: y.level,
            }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }

  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.total;
      },
      error: err => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); },
      complete: () => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); }
    });
  }

  formEvent(data: any) {
    if (data.id) {

      const payload = {
        ...data,
        level: 2
      };

      this.service.updateItem(payload).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {
      const payload = {
        ...data,
        level: 2
      };

      this.service.createItem(payload).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
